export const subPages = [
        {  
            subpage: 'Announcements',
            student: 'announcementsStudent.html',
            teacher: 'announcementsTeacher.html',
        },
        {
            subpage: 'Grades',
            student: 'gradesStudentsPanel.html',
            teacher: 'gradesTeacher.html',
        }
    ]